export default __webpack_public_path__ + "static/media/TL07.1.681bf49c.mp3";